import { hbs } from 'ember-cli-htmlbars';
import { workflowComponent } from '@banking/ui/services/unit-balance';
import { ActionCreator } from '@banking/ui/workflows/balance/card-list';
import { createDebitCardsListItemsFromCards } from './debit-card-list-util';
const template = hbs`
  <Banking::Checking::MultipleCards::DebitCardList
    @allowNewCard={{this.allowNewCard}}
    @closeCardActivationModal={{this.args.closeCardActivationModal}}
    @debitCards={{this.debitCards}}
    @hasError={{this.hasError}}
    @onAddCardButtonClick={{this.onAddCardButtonClick}}
    @productName={{this.args.productName}}
    @refreshAction={{this.refreshAction}}
    @toolTipText={{this.toolTipText}}
    @isLoadingCardList={{this.isLoadingCardList}}
  />`;
const mapStateToProps = (state, ownArgs) => {
  const onActivatableCardClick = unitToken => cardToken => ownArgs.navigateToCardSettingsToActivateCard(unitToken, cardToken);
  const onCardInvitationClick = unitToken => cardInvitationToken => ownArgs.navigateToCardInvitation(unitToken, cardInvitationToken);
  const onCardClick = unitToken => cardToken => ownArgs.navigateToCardSettings(unitToken, cardToken);
  return {
    allowNewCard: state.cardListState.canInviteOrOrderNewCard,
    debitCards: createDebitCardsListItemsFromCards(state.cardListState.cards, onActivatableCardClick(state.unitToken), onCardInvitationClick(state.unitToken), onCardClick(state.unitToken), ownArgs.eventsService),
    hasError: state.cardListState.hasError,
    isLoadingCardList: state.cardListState.isLoading,
    toolTipText: state.cardListState.tooltipText,
    unitToken: state.unitToken
  };
};
const mapActionsToProps = () => ({
  onAddCardButtonClick: ActionCreator.userClickAddDebitCard,
  refreshAction: () => ActionCreator.requestCardList()
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);